export default __webpack_public_path__ + "static/media/project-1.c280d126.jpg";